/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// styles
// import injectSheet from 'react-jss';
// import styles from 'material/embeds/labelassignmentfield/labelassignmentcollection/assignmentfieldinput/assignmentfieldinput_styles';



/* ========== ~~~~~~~~~~ LABEL ASSIGNMENT COLLECTION INPUT  : DROPDOWN ITEM ~~~~~~~~~~ ========== */

/*  IMPORTANT:

We are using React.forwardRef to allow the parent component to access the input field.
The parent component will trigger focus on the input when any changes occur in the collection or when the user clicks on the collection area.

Using React.forwardRef prevents us from utilizing HOC injectSheet as it doesn't pass ref correctly.
We can't update injectSheet to make forwardRef work properly.

Styles for this component are handled in its parent.

*/

export default React.forwardRef((props, ref) => {
    const focusOnInput = () => ref.current.focus();

    const handleKeyDown = event => {
        if(event.key === 'Enter') {
            props.createLabel(props.enteredLabelName);
            focusOnInput()
        } else {
            props.onKeyDown(event)
        }
    };

    return (
        <li className={`assignmentfieldinput ${props.classes.assignmentfieldinput}`} >
            <input type="text"
                   size={'1'}
                   ref={ref}
                   className={`assignmentfieldinputfield`}
                   value={props.enteredLabelName}
                   onChange={props.onChange}
                   onKeyDown={handleKeyDown}
            />
        </li>
    );
})
